<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZT1KH6/tc-custom/9781467447089.jpg?1730410104747" alt="This image is the cover for the book An Introduction to Biblical Law"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">An Introduction to Biblical Law
      </h1>
      <p class="bookDescription body article font2">
        <i>Informed, accessible textbook on law collections in the Pentateuch</i><br/><br/> In this book William Morrow surveys four major law collections in Exodus–Deuteronomy and shows how they each enabled the people of Israel to create and sustain a community of faith.<br/><br/> Treating biblical law as dynamic systems of thought facilitating ancient Israel's efforts at self-definition, Morrow describes four different social contexts that gave rise to biblical law: (1) Israel at the holy mountain (the Ten Commandments); (2) Israel in the village assembly (Exodus 20:22–23:19); (3) Israel in the courts of the Lord (priestly and holiness rules in Exodus, Leviticus, and Numbers); and (4) Israel in the city (Deuteronomy).<br/><br/> Including forthright discussion of such controversial subjects as slavery, revenge, gender inequality, religious intolerance, and contradictions between bodies of biblical law, Morrow's study will help students and other serious readers make sense out of texts in the Pentateuch that are often seen as obscure.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William S. Morrow
      </h2>
      
      <p class="authorDescription body article"><B>William S. Morrow</B>&#160;is professor of Hebrew and Hebrew Scriptures at Queen&#39;s University, Kingston, Ontario. His previous books include&#160;<I>Protest against God: The Eclipse of a Biblical Tradition</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?29708ae2